const STALE_CHUNK_RELOAD_KEY = 'erp-web:stale-chunk-reload'

const CHUNK_LOAD_ERROR_PATTERNS = [
  'failed to fetch dynamically imported module',
  'importing a module script failed',
  'error loading dynamically imported module',
  'unable to preload css',
] as const

function errorMessage(error: unknown): string {
  if (error instanceof Error) {
    return error.message
  }
  return String(error ?? '')
}

export function isChunkLoadError(error: unknown): boolean {
  const message = errorMessage(error).toLowerCase()
  return CHUNK_LOAD_ERROR_PATTERNS.some((pattern) => message.includes(pattern))
}

export function clearStaleChunkReloadFlag(): void {
  if (typeof sessionStorage === 'undefined') {
    return
  }
  sessionStorage.removeItem(STALE_CHUNK_RELOAD_KEY)
}

/** Reload once when a lazy chunk 404s after deploy; returns true if reload was triggered. */
export function reloadForStaleChunk(error: unknown, source: string): boolean {
  if (typeof window === 'undefined' || !isChunkLoadError(error)) {
    return false
  }

  if (sessionStorage.getItem(STALE_CHUNK_RELOAD_KEY)) {
    return false
  }

  sessionStorage.setItem(STALE_CHUNK_RELOAD_KEY, source)
  window.location.reload()
  return true
}

export function registerStaleChunkRecoveryHandlers(): void {
  if (typeof window === 'undefined') {
    return
  }

  window.addEventListener('vite:preloadError', (event) => {
    event.preventDefault()
    reloadForStaleChunk(event.payload, 'vite-preload')
  })
}
